define(["exports", "react", "moment", "styled-components", "../../atoms"], function (_exports, _react, _moment, _styledComponents, _atoms) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _moment = _interopRequireDefault(_moment);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var MessageContainer = _styledComponents.default.li.withConfig({
    displayName: "CommentMsg__MessageContainer",
    componentId: "sc-1366hqy-0"
  })(["border-left:4px solid ", ";display:block;list-style:none;margin-left:20px;padding:1px 0 1px 36px;position:relative;width:90%;> div[data-testid='avatar']{left:-22px;top:6px;position:absolute;}> h3,p{margin:8px 0;max-width:540px;}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  });

  var CommentMsg = function CommentMsg(_ref2) {
    var _message$agente, _message$agente2, _message$agente3, _message$agente4, _message$agente5, _message$agente6;

    var message = _ref2.message;
    return /*#__PURE__*/_react.default.createElement(MessageContainer, null, /*#__PURE__*/_react.default.createElement(_atoms.Avatar, {
      kind: message != null && (_message$agente = message.agente) != null && _message$agente.avatar ? 'image' : 'text',
      name: (message == null ? void 0 : (_message$agente2 = message.agente) == null ? void 0 : _message$agente2.nome) || (message == null ? void 0 : (_message$agente3 = message.agente) == null ? void 0 : _message$agente3.email),
      src: message == null ? void 0 : (_message$agente4 = message.agente) == null ? void 0 : _message$agente4.avatar
    }), /*#__PURE__*/_react.default.createElement(_atoms.H3, null, (message == null ? void 0 : (_message$agente5 = message.agente) == null ? void 0 : _message$agente5.nome) || (message == null ? void 0 : (_message$agente6 = message.agente) == null ? void 0 : _message$agente6.email)), /*#__PURE__*/_react.default.createElement(_atoms.P, null, message == null ? void 0 : message.mensagem), /*#__PURE__*/_react.default.createElement(_atoms.Small, null, (0, _moment.default)(message == null ? void 0 : message.data_criacao).format('DD/MM/YYYY HH:mm')));
  };

  var _default = CommentMsg;
  _exports.default = _default;
});